module.exports = __webpack_public_path__ + "img/75607.1a1f3a71.svg";